// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingDetailActions.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var m = require('mobx');
  var compose = require('recompose').compose;
  var pure = require('recompose').pure;
  var withHandlers = require('recompose').withHandlers;

  var constants = require('logic/data/Izenda.DatabaseMappingConstants');
  var TABLE_DEF = constants.TABLE_DEF;
  const { curry, isObject, isNil, find } = require('lodash/fp');

  var mappingDetailActions = compose(
    pure,
    withHandlers({
      onDeleteMapping:  curry(onDeleteMapping),
      onChangeMergeDuplicateMappings:  curry(onChangeMergeDuplicateMappings),
      onChangeMappingItem:  curry(onChangeMappingItem),
      onChangeDatabaseName:  curry(onChangeDatabaseName),
      onChangeType:  curry(onChangeType),
      onChangeMappingTenant:  curry(onChangeMappingTenant)
    })
  );

  /**
   * Handle on delete mapping item.
   * @param {Object} props
   * @param {Object} mappingItem
   */
  function onDeleteMapping(props, mappingItem) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.deleteMapping(mappingItem.id);
  }

  /**
   * Handle on change merge duplicate mappings.
   * @param {Object} props
   * @param {Boolean} e
   */
  function onChangeMergeDuplicateMappings(props, e) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.setPropertyValue('doesMergeDuplicate', e.target.checked);
  }

  /**
   * Handle on change mapping item.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeMappingItem(props, key, mappingItem, e) {
    mappingItem.setPropertyValue(key, ! isObject(e) ? e :  isNil(e.value) ? e.target.value : e.value);
  }

  /**
   * Handle on change mapping tenant.
   * @param {Object} props
   * @param {Object} e
   */
  function onChangeMappingTenant(props, e) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.setPropertyValue('selectedTenantId', e.value, true);
  }

  /**
   * Handle on change database name.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeDatabaseName(props, key, mappingItem, e) {
    var isFromDatabase = (key === TABLE_DEF.fromDatabaseName.key);
    var dataSource = isFromDatabase ? props.store.fromDatabaseNameDataSource : props.store.toDatabaseNameDataSource;

    var matchedDataSource =  find(function (item) {
      return item[constants.DATABASE_NAME_KEY] === e;
    }, dataSource.items);

    if (!matchedDataSource) return;

    var server = matchedDataSource.databaseServer;
    var databaseName = matchedDataSource.labelField;
    var databaseUser = matchedDataSource.databaseUser;

    m.action(function () {
      onChangeMappingItem(props, key, mappingItem, databaseName);
      onChangeMappingItem(props, isFromDatabase ? 'fromServer' : 'toServer', mappingItem, server);
      onChangeMappingItem(props, isFromDatabase ? 'fromDatabaseUser' : 'toDatabaseUser', mappingItem, databaseUser);
      isFromDatabase && onChangeType(props, 'type', mappingItem, constants.MAPPING_TYPE.Schema);
    })();
  }

  /**
   * Handle on change type.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeType(props, key, mappingItem, e) {
    m.action(function () {
      onChangeMappingItem(props, key, mappingItem, e);
      props.store.loadObjects(mappingItem);
    })();
  }

  /**
   * Handle error validations when user makes an action.
   * @param {Object} props
   */
  function handleErrorValidation(props) {
    props.validation.reset();
  }

  module.exports = mappingDetailActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/MappingDetail/Izenda.MappingDetailActions.js